import { ActionTree } from 'vuex';
import { EntityState } from '@/store/entity/types';
import { RootState } from '@/store/types';
import { getEntityLayout } from '@/http/apiEntity';
import { PimcoreLayoutState } from '@/types/entity';

const actions: ActionTree<EntityState, RootState> = {
  async fetchEntityLayouts({ commit, state }, entityName: string): Promise<void> {
    try {
      commit('setLayoutClass', PimcoreLayoutState.loading);
      const layouts = await getEntityLayout(entityName);
      if (
        state.layoutClass !== entityName
        && layouts.length > 0
      ) {
        commit('loadLayouts', {
          entity: entityName,
          layouts,
        });
        commit('setLayoutClass', entityName);
      } else {
        commit('setLayoutClass', PimcoreLayoutState.loadedEmpty);
      }
    } catch (error) {
      console.error(error.message);
    }
  },
  toggleEntityModal({ commit }, value: boolean): void {
    commit('setModalState', value);
  },
};

export default actions;
